<div class="container mt-4 shadow bg-white mb-5">
  <div class="row">
    <div class="col">
      <div class="float-right pt-4">
        <a href="" style="text-decoration: none" (click)="$event.preventDefault(); $event.stopPropagation(); toggleInactive()">
          <i class="fas fa-2x" [ngClass]="{ 'fa-toggle-off': !this.params.show_inactive, 'fa-toggle-on': this.params.show_inactive }"></i>
          &nbsp;<span style="position: relative; top: -5px">Show Inactive</span>
        </a>
        &nbsp;
        <a style="position: relative; top: -5px" routerLink="/users/new">
          <i class="fas fa-plus"></i>
          &nbsp;New User
        </a>
      </div>
      <h2 class="pt-4 font-weight-light">Users</h2>
      <hr />
    </div>
  </div>
  <div *ngIf="loading" class="m-5 p-5 text-center">
    <i class="fas fa-5x fa-spinner fa-pulse"></i>
  </div>
  <div *ngIf="!loading">
    <div class="row">
      <div class="col-12 col-sm-4 col-md-2 text-center p-4 border-bottom" *ngFor="let user of users">
        <a [routerLink]="'/users/' + user.id + '/edit'">
          <img class="rounded-circle" [src]="'http://gravatar.com/avatar/' + user.gravatar_id + '.png?s=' + user.gravatar_size" />
          <br />
          <p class="mt-1">{{ user.full_name }}</p>
        </a>
      </div>
    </div>
  </div>
</div>
